import { GAME_ID, REDUX_ACTIONS, SCREENS } from 'a/zoomBoom/data/constants';

const initialState = {
  phase: '',
  returnTo: SCREENS.PROGRESS,
  returnToLevel: 0,
};
export const stateSequence = [
  '',
  'playRap',
  'alexInit',
  'alexWordSequnce',
  'sampleQuestion',
  'finish',
];

const onboardingReducer = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_NEXT_ONBOARDING_PHASE: {
      const currentIndex = stateSequence.indexOf(state.phase);
      return {
        ...state,
        phase: stateSequence[currentIndex + 1],
      };
    }

    case REDUX_ACTIONS.RESET_ONBOARDING:
      return initialState;

    case REDUX_ACTIONS.SET_ONBOARDING_RETURN_TO:
      return {
        ...state,
        returnTo: payload.screen,
        returnToLevel: payload.level,
      };

    default:
      return state;
  }
};

export default onboardingReducer;
